import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IntransitParam } from 'src/app/core/models/transport-operation/intransit-param';

@Injectable({
  providedIn: 'root'
})
export class IntransitUpdateService {

  constructor(private http: HttpClient) { }

  queryIntransit(params:IntransitParam):Observable<any>{
    const url = `${environment.logisticsApiUrl}/Intransit/searchIntransit`;
    return this.http.post(url,params);
  }

  importIntransitExcel(file:any):Observable<any>{

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const url = `${environment.logisticsApiUrl}/Intransit/import`;
    return this.http.post(url,formData);
  }

  saveIntransit(data:any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/Intransit/saveIntransit`;
    return this.http.post(url,data);
  }

  exportExcel(param: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Intransit/export`;
    return this.http.post(url, param, { responseType: 'blob'});
  }
}
